module.exports = __webpack_public_path__ + "img/forgot_password.8ba3c373.svg";